import { render, staticRenderFns } from "./choice-color.vue?vue&type=template&id=415ae596&scoped=true&"
import script from "./choice-color.vue?vue&type=script&lang=js&"
export * from "./choice-color.vue?vue&type=script&lang=js&"
import style0 from "./choice-color.vue?vue&type=style&index=0&id=415ae596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415ae596",
  null
  
)

export default component.exports